import { apiAction } from 'actions/application'
import { dataTranslator } from 'services'
import { createAction } from 'actions/utils'

export const GET_ODX_MODULES = 'GET_ODX_MODULES'
export const SUCCESS_ODX_MODULES = 'SUCCESS_ODX_MODULES'
export const getODXModules = () =>
  apiAction({
    asyncFn: dataTranslator.getModules,
    successActionType: SUCCESS_ODX_MODULES,
    requestActionType: GET_ODX_MODULES,
  })

export const GET_MODULE_VARIANTS = 'GET_MODULE_VARIANTS'
export const SUCCESS_MODULES_VARIANTS = 'SUCCESS_MODULES_VARIANTS'
export const getModuleVariants = ({ module }) =>
  apiAction({
    asyncFn: dataTranslator.getModuleVariants,
    args: { module },
    id: module,
    successActionType: SUCCESS_MODULES_VARIANTS,
    requestActionType: GET_MODULE_VARIANTS,
  })

export const GET_VARIANT_DOMAINS = 'GET_VARIANT_DOMAINS'
export const SUCCESS_VARIANT_DOMAINS = 'SUCCESS_VARIANT_DOMAINS'
export const getVariantDomains = ({ module, variant }) =>
  apiAction({
    asyncFn: dataTranslator.getVariantDomains,
    args: { module, variant },
    id: variant,
    successActionType: SUCCESS_VARIANT_DOMAINS,
    requestActionType: GET_VARIANT_DOMAINS,
  })

export const GET_FRAGMENT_DETAILS = 'GET_FRAGMENT_DETAILS'
export const SUCCESS_FRAGMENT_DETAILS = 'SUCCESS_FRAGMENT_DETAILS'
export const fetchFragmentDetails = ({ module, variant, fragment }) =>
  apiAction({
    asyncFn: dataTranslator.getFragmentDetails,
    args: { module, variant, fragment },
    id: variant,
    successActionType: SUCCESS_FRAGMENT_DETAILS,
    requestActionType: GET_FRAGMENT_DETAILS,
  })

export const GET_DOMAIN_PART_NUMBERS = 'GET_DOMAIN_PART_NUMBERS'
export const SUCCESS_DOMAIN_PART_NUMBERS = 'SUCCESS_DOMAIN_PART_NUMBERS'
export const getDomainPartNumbers = ({ module, variant, vcdQualifier }) =>
  apiAction({
    asyncFn: dataTranslator.getDomainPartNumbers,
    args: { module, variant, vcdQualifier },
    id: vcdQualifier,
    successActionType: SUCCESS_DOMAIN_PART_NUMBERS,
    requestActionType: GET_DOMAIN_PART_NUMBERS,
  })

export const GET_PART_DETAILS = 'GET_PART_DETAILS'
export const SUCCESS_PART_DETAILS = 'SUCCESS_PART_DETAILS'
export const getPartDetailList = ({ module, variant, key }) =>
  apiAction({
    asyncFn: dataTranslator.getPartDetailList,
    args: { module, variant, key },
    id: key,
    successActionType: SUCCESS_PART_DETAILS,
    requestActionType: GET_PART_DETAILS,
  })

export const GET_DOMAIN_FRAGMENTS = 'GET_DOMAIN_FRAGMENTS'
export const SUCCESS_DOMAIN_FRAGMENTS = 'SUCCESS_DOMAIN_FRAGMENTS'
export const getDomainFragments = ({ module, variant, vcdQualifier }) =>
  apiAction({
    asyncFn: dataTranslator.getDomainFragments,
    args: { module, variant, vcdQualifier },
    id: vcdQualifier,
    successActionType: SUCCESS_DOMAIN_FRAGMENTS,
    requestActionType: GET_DOMAIN_FRAGMENTS,
  })

export const SET_VARIANT_BREADCRUMB = 'SET_VARIANT_BREADCRUMB'
export const setVariantBreadcrumb = createAction(SET_VARIANT_BREADCRUMB)

export const RESET_VARIANT_BREADCRUMB = 'RESET_VARIANT_BREADCRUMB'
export const resetVariantBreadcrumb = createAction(RESET_VARIANT_BREADCRUMB)

export const SET_FRAGMENT_BREADCRUMB = 'SET_FRAGMENT_BREADCRUMB'
export const setFragmentBreadcrumb = createAction(SET_FRAGMENT_BREADCRUMB, [
  'vcdQualifier',
])

export const RESET_FRAGMENT_BREADCRUMB = 'RESET_FRAGMENT_BREADCRUMB'
export const resetFragmentBreadcrumb = createAction(RESET_FRAGMENT_BREADCRUMB)

export const SET_PART_NUMBER_BREADCRUMB = 'SET_PART_NUMBER_BREADCRUMB'
export const setPartNumberreadcrumb = createAction(SET_PART_NUMBER_BREADCRUMB, [
  'vcdQualifier',
])

export const RESET_PART_NUMBER_BREADCRUMB = 'RESET_PART_NUMBER_BREADCRUMB'
export const resetPartNumberBreadcrumb = createAction(
  RESET_PART_NUMBER_BREADCRUMB
)
